import React, { useEffect, useRef, useState } from "react";
import Navbar from "../navbar/Navbar";
import DataTable, { createTheme } from "react-data-table-component";
import Loader from "../loader/Loader";
import OrderService from "../../services/OrderService";
import OrderCard from "./OrderCard";
import { LuSearchX } from "react-icons/lu";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { useNavigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { API_URL } from "../../constant/Constant";
import CreditCheckService from "../../services/CreditCheckService";
import ModalComponent from "../modalComponent/ModalComponent";
import { useDispatch, useSelector } from "react-redux";
import Button from "../button/Button";
import { closeModal, openModal } from "../modalComponent/modalSlice";
import toast, { Toaster } from "react-hot-toast";
const ModalForCredit = ({
  navigate,
  dispatch,
  handleCheckout,
  checkoutFormRef,
}) => {
  return (
    <div>
      <h2 className="text-md font-semibold mb-2">
        We regret to inform you that you didn't pass our credit checks.
      </h2>
      <p className="text-sm">
        However, we do offer a PAYG SIM option with auto top-up similar to a
        contract. Would you like to proceed with that?
      </p>
      <div className="w-full flex justify-between items-center mt-4">
        <Button
          handleClick={() => {
            dispatch(closeModal());
          }}
          title="No Thanks"
          type="button"
          style="
            rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 text-red-600 bg-transparent border border-red-800 hover:bg-red-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-semibold px-3 py-1.5 text-center
            "
        />
        <Button
          handleClick={() => {
            // handleCheckout();
            navigate("/free-sim");
            dispatch(closeModal());
            if (checkoutFormRef.current) {
              checkoutFormRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }}
          title="Proceed"
          type="button"
          style="cta-two"
        />
      </div>
    </div>
  );
};

const ModalForReferral = ({ navigate, dispatch }) => {
  return (
    <div>
      <h2 className="text-md font-semibold mb-2">
      We're currently verifying your credit status with our agency to process your SIMO order. We can only proceed with your order upon successful credit approval. We'll notify you as soon as we have an update, or you may check your status again in 30 minutes.
      </h2>
      {/* <p className="text-sm">
        However, we do offer a PAYG SIM option with auto top-up similar to a
        contract. Would you like to proceed with that?
      </p> */}
      <div className="w-full flex justify-center items-center gap-4">
        <Button
          handleClick={() => {
            // navigate("/");
            dispatch(closeModal());
          }}
          title="Okay"
          type="button"
          // style="
          //   rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 text-red-600 bg-transparent border border-red-800 hover:bg-red-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-semibold px-3 py-1.5 text-center
          //   "
          style="cta-two"
        />
        {/* <Button
          handleClick={() => {
            // handleCheckout();
            navigate("/free-sim");
            dispatch(closeModal());
            if (checkoutFormRef.current) {
              checkoutFormRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }}
          title="Proceed"
          type="button"
          style="cta-two"
        /> */}
      </div>
    </div>
  );
};
const MyOrder = () => {
  //states
  const [rows, setRows] = useState([]);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const userId = localStorage.getItem("userId") || "";
  const userRoleId = localStorage.getItem("roleId") || "";
  const [errors, setErrors] = useState({});
  const [startDate, setStartDate] = useState(""); // State for start date
  const [endDate, setEndDate] = useState(""); // State for end date
  const navigate = useNavigate();
  const [orderStatusError, setOrderStatusError] = useState("");
  const [orderStatusOptions, setOrderStatusOptions] = useState([]);
  const [orderStatus, setOrderStatus] = useState("0");
  const { orderId } = useParams();

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const dispatch = useDispatch();
  const modalInitState = useSelector((state) => state.modal);
  const checkoutFormRef = useRef(null);
  const [enableCheckout, setEnableCheckout] = useState(false);

  // const navigate = useNavigate(;
  //initialize
  var columns = [];
  if (userRoleId != null && userRoleId === "ROLE_DEALER") {
    columns = [
      {
        name: "Order Created Date",
        selector: (row) => row.createdDate,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Order Completed Date",
        selector: (row) => row.orderCompletedDate ? row.orderCompletedDate : " --- ",
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Order Number",
        selector: (row) => row.orderNumber,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Order Amount",
        selector: (row) => row.amount,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Order Status",
        selector: (row) => row.orderStatusDescription,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Order Type",
        selector: (row) => row.orderTypeDescription,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Delivery Type",
        selector: (row) => row.orderCreatedTypeDescription ? row.orderCreatedTypeDescription : "---",
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Customer Name",
        selector: (row) => row.username,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      // {
      //   name: "Email ID",
      //   selector: (row) => row.email,
      //   sortable: true,
      //   wrap: true,
      //   minWidth: "200px",
      // },
      {
        name: "Plan Name",
        selector: (row) => row.tariffName,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Data",
        selector: (row) => row.planData,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Minutes",
        selector: (row) => row.noOfMinutes,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Text",
        selector: (row) => row.noOfText,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Validity",
        selector: (row) => row.contractTerm,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Network",
        selector: (row) => row.networkName,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      // {
      //   name: "Mobile Number",
      //   selector: (row) => row.lockMsisdn,
      //   sortable: true,
      //   wrap: true,
      //   minWidth: "200px",
      // },
      {
        name: "ICCID",
        selector: (row) => row.iccid ? row.iccid : "---",
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Port In?",
        selector: (row) => row.mobileNoSelectionId,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Signup Commission",
        selector: (row) => row.signupCommission,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Order Commission",
        selector: (row) => row.orderCommission,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Total Commission",
        selector: (row) => row.totalCommission,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Credit vetting Status",
        selector: (row) => row.decisionValue || "---",
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Process Order",
        cell: (row) =>
          row.decision === 1 ? (
            <button
              onClick={() =>
                handleProcessOrder(
                  row.decisionValue,
                  row.orderId,
                  row.orderNumber,
                  row.createdDate,
                  row.planId
                )
              }
              className="cta-one px-3 py-2 rounded-lg"
            >
              Process Order
            </button>
          ) : (
            "---"
          ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        minWidth: "200px",
      },
    ];
  } else {
    columns = [
      {
        name: "Order Date",
        selector: (row) => row.createdDate,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Order Number",
        selector: (row) => row.orderNumber,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Order Amount",
        selector: (row) => row.amount,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Order Status",
        selector: (row) => row.orderStatusDescription,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Order Type",
        selector: (row) => row.orderTypeDescription,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Plan Name",
        selector: (row) => row.tariffName,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Data",
        selector: (row) => row.planData,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Minutes",
        selector: (row) => row.noOfMinutes,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Text",
        selector: (row) => row.noOfText,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Validity",
        selector: (row) => row.contractTerm,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Network",
        selector: (row) => row.networkName,
        sortable: true,
        wrap: true,
        minWidth: "100px",
      },
      {
        name: "Mobile Number",
        selector: (row) => row.lockMsisdn,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
      {
        name: "Port In?",
        selector: (row) => row.mobileNoSelectionId,
        sortable: true,
        wrap: true,
        minWidth: "200px",
      },
    ];
  }
  const tableCustomStyles = {
    headCells: {
      style: {
        border: "1px solid black",
        fontSize: "20px",
        fontWeight: "bold",
        paddingLeft: "0 8px",
        justifyContent: "center",
        backgroundColor: "#FFA500",
      },
    },
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    cells: {
      style: {
        border: "1px solid black",
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };
  createTheme(
    "solarized",
    {
      text: {
        primary: "#268bd2",
        secondary: "#2aa198",
      },
      background: {
        default: "#002b36",
      },
      context: {
        background: "#cb4b16",
        text: "#FFFFFF",
      },
      divider: {
        default: "#073642",
      },
      action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "dark"
  );
  const handleCheckout = () => {
    setEnableCheckout(true);
    toast.success("Proceed to checkout", {
      style: {
        border: "1px solid #6ea8ad",
        backgroundColor: "#5a949a",
        color: "#f6f6f2",
      },
    });
    if (checkoutFormRef.current) {
      checkoutFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  // //effects
  //   const fetchData = async () => {
  //   setLoader(true);

  //   await OrderService.getOrder(userId, startDate, endDate)
  //     .then((response) => {
  //       if (response.status == 200) {
  //         const list = response.data;
  //         console.log("list", list);

  //         setData([]);
  //         setRows([]);
  //         if (list != null && list.length > 0) {
  //           let tempList = [];
  //           list.forEach((order) => {
  //             tempList.push({
  //               id: order.orderId,
  //               createdDate:
  //                 order.createdDate &&
  //                 order.createdDate
  //                   .toString()
  //                   .substring(0, 19)
  //                   .replace("T", " ") + " GMT",
  //               orderNumber: order.orderNumber,
  //               amount: "£" + order.amount,
  //               orderStatusDescription:
  //                 order.orderStatus.orderStatusDescription,
  //               orderTypeDescription: order.orderType.orderTypeDescription,
  //               username: order.creditCheck.customer.name,
  //               email: order.creditCheck.customer.email,
  //               tariffName: order.creditCheck.plan.tariffName,
  //               planData:
  //                 order.creditCheck.plan.data === 30
  //                   ? "Unlimited"
  //                   : `${order.creditCheck.plan.data} GB`,
  //               noOfMinutes:
  //                 order.creditCheck.plan.noOfMinutes === -1
  //                   ? "Unlimited"
  //                   : order.creditCheck.plan.noOfMinutes,
  //               noOfText:
  //                 order.creditCheck.plan.noOfText === -1
  //                   ? "Unlimited"
  //                   : order.creditCheck.plan.noOfText,
  //               contractTerm: order.creditCheck.plan.contractTerm + " Months",
  //               networkId: order.creditCheck.plan.network.networkId,
  //               networkName: order.creditCheck.plan.network.networkName,
  //               lockMsisdn:
  //                 order.creditCheck.lockMsisdn &&
  //                 "+" + order.creditCheck.lockMsisdn,
  //               iccid: order.creditCheck.iccid,
  //               signupCommission: "£" +order.signupCommission,
  //               orderCommission: "£" +order.orderCommission,
  //               totalCommission: "£" +order.totalCommission,

  //             });
  //           });

  //           setData(tempList);
  //           setRows(tempList);
  //         }
  //         setLoader(false);
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.message === "Network Error") {
  //         setErrors((prev) => ({
  //           ...prev,
  //           orderFetch: "Network error occurred. Please try again later.",
  //         }));
  //         setLoader(false);
  //       } else {
  //         switch (error.response ? error.response.status : "") {
  //           case 401:
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch: error.response.data.failedReason,
  //             }));
  //             break;
  //           case 403:
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch: error.response.data.failedReason,
  //             }));
  //             break;
  //           case 500:
  //             console.log("Error: ", error.response.data.failedReason);
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch:
  //                 "Internal server error occurred. Please try again later.",
  //             }));
  //             break;
  //           case 404:
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch: error.response.data.failedReason,
  //             }));
  //             break;
  //           case 406:
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch: error.response.data.failedReason,
  //             }));
  //             break;
  //           case 412:
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch: error.response.data.failedReason,
  //             }));
  //             break;
  //           default:
  //             setErrors((prev) => ({
  //               ...prev,
  //               orderFetch: "Unknown error occurred. Please try again later.",
  //             }));
  //             break;
  //         }
  //         setLoader(false);
  //       }
  //     });

  //   setLoader(false);
  //   fetchData();
  // // }, []);
  // };

  // },[startDate, endDate, userId]);

  // useEffect(() => {
  //     const today = new Date();
  //     const formattedDate = formatDate(today);
  //     setStartDate(formattedDate);
  //     setEndDate(formattedDate);
  //   }, []);
  useEffect(() => {
    const today = new Date();

    // Set endDate to today's date
    const formattedEndDate = formatDate(today);

    // Set startDate to the 1st of the current month
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const formattedStartDate = formatDate(startOfMonth);

    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);

    fetchData(
      formattedStartDate,
      formattedEndDate,
      orderStatus === "0" ? 0 : orderStatus
    );
    //call order status api
    getOrderStatus();
  }, [orderStatus]);

  const getOrderStatus = async () => {
    try {
      const response = await axios.get(`${API_URL}api/v1/orderStatus`);

      if (response.status === 200) {
        // console.log("response", response.data);
        setOrderStatusOptions(response.data);
        // setLoader(false);
        // Handle successful response here (e.g., set order status data)
      }
    } catch (error) {
      setLoader(false);
      // setSubmitLoader(false);

      if (!error.response) {
        setOrderStatusError("Network error occurred. Please try again later.");
        return;
      }

      switch (error.response.status) {
        case 400:
        case 403:
        case 404:
          setOrderStatusError(
            "Failed to fetch order status. Please try again later."
          );
          break;
        case 500:
          setOrderStatusError("Server error occurred. Please try again later.");
          break;
        default:
          setOrderStatusError(
            "Unknown error occurred. Please try again later."
          );
          break;
      }
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);
  };

  const handleOrderStatusChange = (e) => {
    const selectedOrderStatusId = e.target.value;
    setOrderStatus(selectedOrderStatusId);
  };

  // Fetch data based on date range
  const fetchData = async (startDate, endDate, orderStatusId) => {
    if (startDate > endDate) {
      setErrors((prev) => ({
        ...prev,
        orderFetch: "Please Select valid Date",
      }));
      return;
    }
    const token = localStorage.getItem("accesstoken");
    if (!token) {
      localStorage.clear();
      navigate("/login");
      return;
    }
    const tokenData = jwtDecode(token);
    const exp = tokenData.exp;
    const currentTime = Math.floor(Date.now() / 1000);
    if (!token || exp < currentTime) {
      //alert("Session Expired");
      localStorage.removeItem("token");
      localStorage.removeItem("accesstoken");
      localStorage.removeItem("email");
      localStorage.removeItem("emailId");
      localStorage.removeItem("name");
      localStorage.removeItem("username");
      localStorage.removeItem("id");
      localStorage.removeItem("userId");
      localStorage.removeItem("isVerified");
      localStorage.removeItem("roleId");
      localStorage.removeItem("loggedIn");
      localStorage.removeItem("reffralCode");

      localStorage.removeItem("dealerId");
      localStorage.removeItem("dealerFirstName");
      localStorage.removeItem("dealerLastName");
      localStorage.removeItem("dealerEmailId");
      localStorage.removeItem("emailId");
      localStorage.removeItem("dealerSignup");
      localStorage.removeItem("accesstoken");
      localStorage.removeItem("username");
      localStorage.removeItem("dealerUsername");
      localStorage.removeItem("dealerPassword");
      localStorage.removeItem("dealerAccesstoken");
      localStorage.removeItem("verifiedCount");
      localStorage.removeItem("name");
      navigate("/login");
      return;
    }
    setLoader(true);

    try {
      const response = await OrderService.getOrder(
        startDate,
        endDate,
        orderStatusId === "0" ? 0 : orderStatusId,
        0
      );
      if (response.status === 200) {
        const list = response.data;
        // console.log("list==>", list);
        setData([]);
        setRows([]);
        if (list != null && list.length > 0) {
          let tempList = [];
          list.forEach((order) => {
            tempList.push({
              createdDate:
                order.createdDate &&
                order.createdDate
                  .toString()
                  .substring(0, 19)
                  .replace("T", " ") + " GMT",
              orderCompletedDate: order.orderCompletedDate &&
                  order.orderCompletedDate
                      .toString()
                      .substring(0, 19)
                      .replace("T", " ") + " GMT",
              orderNumber: order.orderNumber,
              amount: "£" + order.amount,
              orderStatusDescription: order.orderStatus.orderStatusDescription,
              orderTypeDescription: order.orderType.orderTypeDescription,
              orderCreatedTypeDescription:
                order.deliveryType.deliveryTypeDescription,
              username: order.creditCheck.customer.name,
              email: order.creditCheck.customer.email,
              tariffName: order.creditCheck.plan.tariffName,
              planData:
                order.creditCheck.plan.data === -1
                  ? "Unlimited"
                  : `${order.creditCheck.plan.data} GB`,
              noOfMinutes:
                order.creditCheck.plan.noOfMinutes === -1
                  ? "Unlimited"
                  : order.creditCheck.plan.noOfMinutes,
              noOfText:
                order.creditCheck.plan.noOfText === -1
                  ? "Unlimited"
                  : order.creditCheck.plan.noOfText,
              contractTerm: order.creditCheck.plan.contractTerm + " Months",
              networkId: order.creditCheck.plan.network.networkId,
              networkName: order.creditCheck.plan.network.networkName,
              lockMsisdn:
                order.creditCheck.lockMsisdn &&
                "0" + order.creditCheck.lockMsisdn,
              iccid: order.creditCheck.iccid,
              mobileNoSelectionId:
                order.creditCheck.mobileNumberSelection.mobileNoSelectionId ===
                1
                  ? "New Number"
                  : order.creditCheck.mobileNumberSelection
                      .mobileNoSelectionId === 2 ||
                    order.creditCheck.mobileNumberSelection
                      .mobileNoSelectionId === 3
                  ? "Port In"
                  : "",
              signupCommission: "£" + order.signupCommission,
              orderCommission: "£" + order.orderCommission,
              totalCommission: "£" + order.totalCommission,
              decision: order.orderStatus.orderStatusId,
              decisionValue: order.creditCheck.decision,
              planId: order.creditCheck.plan.planId,
              orderId: order.orderId,
            });
          });

          setData(tempList);
          setRows(tempList);
        }
      }
    } catch (error) {
      if (error.message === "Network Error") {
        setErrors((prev) => ({
          ...prev,
          orderFetch: "Network error occurred. Please try again later.",
        }));
        setLoader(false);
      } else {
        switch (error.response ? error.response.status : "") {
          case 401:
            setErrors((prev) => ({
              ...prev,
              orderFetch: error.response.data.failedReason,
            }));
            break;
          case 403:
            setErrors((prev) => ({
              ...prev,
              orderFetch: error.response.data.failedReason,
            }));
            break;
          case 500:
            setErrors((prev) => ({
              ...prev,
              orderFetch:
                "Internal server error occurred. Please try again later.",
            }));
            break;
          case 404:
            setErrors((prev) => ({
              ...prev,
              orderFetch: error.response.data.failedReason,
            }));
            break;
          case 406:
            setErrors((prev) => ({
              ...prev,
              orderFetch: error.response.data.failedReason,
            }));
            break;
          case 412:
            setErrors((prev) => ({
              ...prev,
              orderFetch: error.response.data.failedReason,
            }));
            break;
          default:
            setErrors((prev) => ({
              ...prev,
              orderFetch: "Unknown error occurred. Please try again later.",
            }));
            break;
        }
        setLoader(false);
      }
    } finally {
      setLoader(false);
    }

    //if orderId is not null or empty, then fetch the order with orderId
    if (orderId && orderId !== "") {
      setLoader(true);
      try {
        const response = await OrderService.getOrder(
          startDate,
          endDate,
          orderStatusId === "0" ? 0 : orderStatusId,
          orderId
        );
        if (response.status === 200) {
          const list = response.data;
          // console.log("list==>", list);
          let tempProcessOrder = undefined;
          if (list != null && list.length > 0) {
            list.forEach((order, index) => {
              // Set first order into processOrder
              if (index === 0) {
                tempProcessOrder = {
                  createdDate: order.createdDate && order.createdDate.toString().substring(0, 19).replace("T", " ") + " GMT",
                  orderNumber: order.orderNumber,
                  amount: "£" + order.amount,
                  orderStatusId: order.orderStatus.orderStatusId,
                  orderStatusDescription: order.orderStatus.orderStatusDescription,
                  orderTypeDescription: order.orderType.orderTypeDescription,
                  orderCreatedTypeDescription: order.deliveryType.deliveryTypeDescription,
                  username: order.creditCheck.customer.name,
                  email: order.creditCheck.customer.email,
                  tariffName: order.creditCheck.plan.tariffName,
                  planData: order.creditCheck.plan.data === -1 ? "Unlimited" : `${order.creditCheck.plan.data} GB`,
                  noOfMinutes: order.creditCheck.plan.noOfMinutes === -1 ? "Unlimited" : order.creditCheck.plan.noOfMinutes,
                  noOfText: order.creditCheck.plan.noOfText === -1 ? "Unlimited" : order.creditCheck.plan.noOfText,
                  contractTerm: order.creditCheck.plan.contractTerm + " Months",
                  networkId: order.creditCheck.plan.network.networkId,
                  networkName: order.creditCheck.plan.network.networkName,
                  lockMsisdn: order.creditCheck.lockMsisdn && "0" + order.creditCheck.lockMsisdn,
                  iccid: order.creditCheck.iccid,
                  mobileNoSelectionId: order.creditCheck.mobileNumberSelection.mobileNoSelectionId === 1 
                    ? "New Number" 
                    : order.creditCheck.mobileNumberSelection.mobileNoSelectionId === 2 || order.creditCheck.mobileNumberSelection.mobileNoSelectionId === 3
                      ? "Port In"
                      : "",
                  signupCommission: "£" + order.signupCommission,
                  orderCommission: "£" + order.orderCommission, 
                  totalCommission: "£" + order.totalCommission,
                  decision: order.orderStatus.orderStatusId,
                  decisionValue: order.creditCheck.decision,
                  planId: order.creditCheck.plan.planId,
                  orderId: order.orderId
                };
              }
            });
          }
          //process the order
          setLoader(false);
          if (tempProcessOrder) {
            if(tempProcessOrder.orderStatusId === 1 || tempProcessOrder.orderStatusId === 3){//order status pending or failed
              handleProcessOrder(tempProcessOrder.decisionValue, tempProcessOrder.orderId, tempProcessOrder.orderNumber, tempProcessOrder.createdDate, tempProcessOrder.planId);
            }else{
              setErrors((prev) => ({
                ...prev,
                orderFetch: "Order is already processed.",
              }));
            }
          }
        }
      } catch (error) {
        if (error.message === "Network Error") {
          setErrors((prev) => ({
            ...prev,
            orderFetch: "Network error occurred. Please try again later.",
          }));
          setLoader(false);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              setErrors((prev) => ({
                ...prev,
                orderFetch: error.response.data.failedReason,
              }));
              break;
            case 403:
              setErrors((prev) => ({
                ...prev,
                orderFetch: error.response.data.failedReason,
              }));
              break;
            case 500:
              setErrors((prev) => ({
                ...prev,
                orderFetch:
                  "Internal server error occurred. Please try again later.",
              }));
              break;
            case 404:
              setErrors((prev) => ({
                ...prev,
                orderFetch: error.response.data.failedReason,
              }));
              break;
            case 406:
              setErrors((prev) => ({
                ...prev,
                orderFetch: error.response.data.failedReason,
              }));
              break;
            case 412:
              setErrors((prev) => ({
                ...prev,
                orderFetch: error.response.data.failedReason,
              }));
              break;
            default:
              setErrors((prev) => ({
                ...prev,
                orderFetch: "Unknown error occurred. Please try again later.",
              }));
              break;
          }
          setLoader(false);
        }
      } finally {
        setLoader(false);
      }
      return;
    }
  };

  const isWithin48Hours = (orderCreateDate) => {
    const orderDate = new Date(orderCreateDate); // Convert order date string to Date object
    const currentDate = new Date(); // Get the current date and time

    const timeDifference = currentDate - orderDate; // Difference in milliseconds
    const hoursDifference = timeDifference / (1000 * 60 * 60); // Convert to hours

    return hoursDifference <= 48; // Returns true if within 48 hours
  };
  const handleProcessOrder = async (
    decisionValue,
    orderId,
    orderNumber,
    createdDate,
    planId
  ) => {
    // console.log("Decision:", decisionValue);
    console.log("orderId:", orderId);
    // console.log("orderNumber:", orderNumber);
    // console.log("createdDate:", createdDate);
    console.log("planId:", planId);
    const userId = localStorage.getItem("userId");
    const loggedIn = localStorage.getItem("loggedIn");

    //find IP and plan
    let userIp = undefined;
    setLoader(true);
    await axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let data = response.data;
        localStorage.setItem("userIP", data.ip);
        userIp = data.ip;
      })
      .catch((error) => {
        //console.log("error", error);
      });
      
    const addFetchOrderRequest = {
      planId: planId,
      userLoggedIn: true,
      orderId: orderId,
      userId: loggedIn ? userId : null,
      userIp: userIp,
    };

    try {
      setLoader(true);

      if (decisionValue === "ACCEPT") {
        const within48Hours = isWithin48Hours(createdDate);
        const response = await CreditCheckService.fetchCreditCheck(
          addFetchOrderRequest
        );

        if (response.status === 200) {
          const tempDetailsForCreditVetting = response.data;
          // console.log("Credit Check Data:", tempDetailsForCreditVetting);
          localStorage.setItem(
            "tempDetailsForCreditVetting",
            JSON.stringify(tempDetailsForCreditVetting)
          );

          if (within48Hours) {
            localStorage.setItem("creditVettingStatus", "ACCEPT&48Hr");
          } else {
            localStorage.setItem("creditVettingStatus", "ACCEPT");
          }

          navigate("/productDetails");
        } else {
          console.error("Failed response:", response);
        }
      } else if (decisionValue === "DECLINE") {
        // console.log("Handling DECLINE decision");
        const response = await CreditCheckService.fetchCreditCheck(
          addFetchOrderRequest
        );
        if (response.status === 200) {
          const tempDetailsForCreditVetting = response.data;
          // console.log("Credit Check Data:", tempDetailsForCreditVetting);
          localStorage.setItem(
            "tempDetailsForCreditVetting",
            JSON.stringify(tempDetailsForCreditVetting)
          );
          localStorage.setItem("creditVettingStatus", "DECLINE");
          dispatch(openModal("creditCheck"));
        }
      } else if (decisionValue === null) {
        localStorage.setItem("creditVettingStatus", "NULL");
        navigate("/productDetails");
      } else if (decisionValue === "REFERRAL") {
        // console.log("Handling REFERRAL decision");
        try {
          const response = await axios.get(
            `${API_URL}api/v1/retriveCreditVettingStatus`,
            {
              headers: {
                // "Content-Type": "application/json",
                // Accept: "application/json",
                orderNumber: orderNumber,
              },
            }
          );

          // console.log("Credit Vetting Status:", response.data);

          if (response.data.status === "ACCEPT") {
            const within48Hours = isWithin48Hours(createdDate);
            const response = await CreditCheckService.fetchCreditCheck(
              addFetchOrderRequest
            );

            if (response.status === 200) {
              const tempDetailsForCreditVetting = response.data;
              // console.log("Credit Check Data:", tempDetailsForCreditVetting);
              localStorage.setItem(
                "tempDetailsForCreditVetting",
                JSON.stringify(tempDetailsForCreditVetting)
              );

              if (within48Hours) {
                localStorage.setItem("creditVettingStatus", "ACCEPT&48Hr");
              } else {
                localStorage.setItem("creditVettingStatus", "ACCEPT");
              }

              navigate("/productDetails");
            } else {
              console.error("Failed response:", response);
            }
          } else if (response.data.status === "DECLINE") {
            const response = await CreditCheckService.fetchCreditCheck(
              addFetchOrderRequest
            );
            if (response.status === 200) {
              const tempDetailsForCreditVetting = response.data;
              localStorage.setItem(
                "tempDetailsForCreditVetting",
                JSON.stringify(tempDetailsForCreditVetting)
              );
              localStorage.setItem("creditVettingStatus", "DECLINE");
              dispatch(openModal("creditCheck"));
            }
          } else if (response.data.status === "REFERRAL") {
            dispatch(openModal("referralPopup"));
          } else if (response.data.status === "FAILURE") {
            console.log("error occuress retrive credit Check status");
          }
        } catch (error) {
          console.error("Error occured while calling the :", error);
        }
      }
    } catch (error) {
      console.error("Error processing order:", error);
    } finally {
      setLoader(false);
    }
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        row.orderStatusDescription &&
        row.orderStatusDescription.trim() === "Cancelled",
      style: {
        backgroundColor: "#ffdddd",
        // color: 'white',
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
    {
      when: (row) =>
        row.orderStatusDescription &&
        row.orderStatusDescription.trim() !== "Cancelled",
      style: {
        backgroundColor: "transparent",
        // color: 'white',
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];
  //functions
  // Handle Search
  // const handleSearch = (e) => {
  //   let searchValue = false;

  //   const newRows = rows.filter((row) => {
  //     console.log("row==",row);
  //     if (userRoleId != null && userRoleId === "ROLE_DEALER") {
  //       if (
  //         row.createdDate.toString().includes(e.target.value.toString()) ||
  //         row.orderNumber
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.amount.toString().includes(e.target.value.toString()) ||
  //         row.orderStatusDescription
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.orderTypeDescription
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.username
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.email
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.tariffName
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.planData.toString().includes(e.target.value.toString()) ||
  //         row.noOfMinutes
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.noOfText
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.contractTerm
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.networkName
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.lockMsisdn?.toString().includes(e.target.value.toString()) ||
  //         row.iccid?.toString().includes(e.target.value.toString()) ||
  //         row.startDate?.toString.includes(e.target.value.toString())||
  //         row.endDate?.toString.includes(e.target.value.toString())
  //       ) {
  //         searchValue = true;
  //       } else {
  //         searchValue = false;
  //       }
  //     } else {
  //       if (
  //         row.createdDate.toString().includes(e.target.value.toString()) ||
  //         row.orderNumber
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.amount.toString().includes(e.target.value.toString()) ||
  //         row.orderStatusDescription
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.orderTypeDescription
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.tariffName
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.planData.toString().includes(e.target.value.toString()) ||
  //         row.noOfMinutes
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.noOfText
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.contractTerm
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.networkName
  //           .toString()
  //           .toLowerCase()
  //           .includes(e.target.value.toString().toLowerCase()) ||
  //         row.lockMsisdn?.toString().includes(e.target.value.toString())||
  //         row.startDate?.toString.includes(e.target.value.toString())||
  //         row.endDate?.toString.includes(e.target.value.toString())
  //       ) {
  //         searchValue = true;
  //       } else {
  //         searchValue = false;
  //       }
  //     }
  //     return searchValue;
  //   });

  //   setData(newRows);
  // };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toString().toLowerCase();

    const newRows = rows.filter((row) => {
      if (userRoleId === "ROLE_DEALER") {
        // For DEALERS, check all fields
        const dealerFields = [
          row.createdDate?.toString() || "",
          row.orderCompletedDate?.toString() || " - ",
          row.orderNumber?.toString().toLowerCase() || "",
          row.amount?.toString() || "",
          row.orderStatusDescription?.toString().toLowerCase() || "",
          row.orderTypeDescription?.toString().toLowerCase() || "",
          row.orderCreatedTypeDescription?.toString().toLowerCase() || "",
          row.username?.toString().toLowerCase() || "",
          row.email?.toString().toLowerCase() || "",
          row.tariffName?.toString().toLowerCase() || "",
          row.planData?.toString() || "",
          row.noOfMinutes?.toString().toLowerCase() || "",
          row.noOfText?.toString().toLowerCase() || "",
          row.contractTerm?.toString().toLowerCase() || "",
          row.networkName?.toString().toLowerCase() || "",
          row.lockMsisdn?.toString() || "",
          row.iccid?.toString() || "",
          row.decisionValue?.toString() || "",
        ];

        // If any of the dealer fields match the search term, return true
        return dealerFields.some((field) => field.includes(searchTerm));
      } else {
        // For NON-DEALERS, only check the specified fields
        return (
          row.createdDate?.toString().includes(e.target.value.toString()) ||
          row.orderNumber?.toString().toLowerCase().includes(searchTerm) ||
          row.amount?.toString().includes(e.target.value.toString()) ||
          row.orderStatusDescription
            ?.toString()
            .toLowerCase()
            .includes(searchTerm) ||
          row.orderTypeDescription
            ?.toString()
            .toLowerCase()
            .includes(searchTerm) ||
          row.tariffName?.toString().toLowerCase().includes(searchTerm) ||
          row.planData?.toString().includes(e.target.value.toString()) ||
          row.noOfMinutes?.toString().toLowerCase().includes(searchTerm) ||
          row.noOfText?.toString().toLowerCase().includes(searchTerm) ||
          row.contractTerm?.toString().toLowerCase().includes(searchTerm) ||
          row.networkName?.toString().toLowerCase().includes(searchTerm) ||
          row.lockMsisdn?.toString().includes(e.target.value.toString())
        );
      }
    });

    setData(newRows);
  };

  const exportToExcel = (data) => {
    // console.log("data==>",data);
    let transformedData = [];
    const filteredData = data.filter((order) => {
      if (userRoleId !== null && userRoleId === "ROLE_DEALER") {
        transformedData = data.map((order) => ({
          "Order Created Date": order.createdDate || "",
          "Order Completed Date": order.orderCompletedDate || "",
          "Order Number": order.orderNumber || "",
          "Order Amount":
            order.orderTypeDescription === "Contract Sim"
              ? order.amount !== undefined
                ? order.amount
                : ""
              : "-",
          "Order Status": order.orderStatusDescription || "",
          "Order Type":
            order.orderTypeDescription !== "Contract Sim"
              ? "PAYM"
              : order.orderTypeDescription || "",
          "Delivery Type": order.deliveryType.deliveryTypeDescription || "",
          "Customer Name": order.username || "",
          // "Email ID": order.email || "",
          "Plan Name":
            order.orderTypeDescription !== "Contract Sim"
              ? "Pay As You Go Sim"
              : order.tariffName || "",
          Data:
            order.orderTypeDescription === "Contract Sim"
              ? order.planData || ""
              : "-",
          Minutes:
            order.orderTypeDescription === "Contract Sim"
              ? order.noOfMinutes || ""
              : "-",
          Text:
            order.orderTypeDescription === "Contract Sim"
              ? order.noOfText || ""
              : "-",
          Validity:
            order.orderTypeDescription === "Contract Sim"
              ? order.contractTerm || ""
              : "-",
          Network: order.networkName || "",
          // "Mobile Number":
          //   order.orderTypeDescription === "Contract Sim"
          //     ? order.lockMsisdn || ""
          //     : "-",
          ICCID:
            order.orderTypeDescription === "Contract Sim"
              ? order.iccid || ""
              : "-",
          "Port In?":
            order.orderTypeDescription === "Contract Sim"
              ? order.mobileNoSelectionId || ""
              : "New Number",
          "Signup Commission": order.signupCommission || "",
          "Order Commission": order.orderCommission || "",
          "Total Commission": order.totalCommission || "",
        }));
      } else {
        transformedData = data.map((order) => ({
          "Order Date": order.createdDate || "",
          "Order Number": order.orderNumber || "",
          "Order Amount":
            order.orderTypeDescription === "Contract Sim"
              ? order.amount !== undefined
                ? order.amount
                : ""
              : "-",
          // "Order Amount": order.amount !== undefined ? order.amount : "",
          "Order Status": order.orderStatusDescription || "",
          "Order Type":
            order.orderTypeDescription !== "Contract Sim"
              ? "PAYM"
              : order.orderTypeDescription || "",
          "Customer Name": order.username || "",
          "Email ID": order.email || "",
          "Plan Name":
            order.orderTypeDescription !== "Contract Sim"
              ? "Pay As You Go Sim"
              : order.tariffName || "",
          Data:
            order.orderTypeDescription === "Contract Sim"
              ? order.planData || ""
              : "-",
          Minutes:
            order.orderTypeDescription === "Contract Sim"
              ? order.noOfMinutes || ""
              : "-",
          Text:
            order.orderTypeDescription === "Contract Sim"
              ? order.noOfText || ""
              : "-",
          Validity:
            order.orderTypeDescription === "Contract Sim"
              ? order.contractTerm || ""
              : "-",
          Network: order.networkName || "",
          "Mobile Number":
            order.orderTypeDescription === "Contract Sim"
              ? order.lockMsisdn || ""
              : "-",
          ICCID:
            order.orderTypeDescription === "Contract Sim"
              ? order.iccid || ""
              : "-",
          "Port In?":
            order.orderTypeDescription === "Contract Sim"
              ? order.mobileNoSelectionId || ""
              : "New Number",
          // "Signup Commission": order.signupCommission || "",
          // "Order Commission": order.orderCommission || "",
          // "Total Commission": order.totalCommission || "",
        }));
      }
    });
    // Create a new worksheet
    const worksheet = XLSX.utils.json_to_sheet(transformedData);

    // Create a new workbook
    const workbook = {
      Sheets: { Orders: worksheet },
      SheetNames: ["Orders"],
    };

    // Convert workbook to a buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Get the current date
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const filename = `Order Data ${formattedDate}.xlsx`;

    // Save the file with the generated filename
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(dataBlob, filename);
  };

  return (
    <>
      <script src=""></script>
      <Navbar />
      {errors?.orderFetch && (
        <p className="error-text text-center">{errors.orderFetch}</p>
      )}
      <div className="mt-3">
        <main className="my-order-table mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between border-b border-gray-200 py-6">
            {userRoleId === "ROLE_DEALER" ? (
              <h1 className="text-2xl font-semibold tracking-tight mb-3">
                Customer Order Data
              </h1>
            ) : (
              <h1 className="text-2xl font-semibold tracking-tight mb-3">
                My Plans
              </h1>
            )}

            <div className="relative w-34 ml-2">
              <select
                name="orderStatus"
                value={orderStatus}
                onChange={handleOrderStatusChange}
                className="rounded-lg bg-transparent border custom-border-50 focus:border-2 focus:custom-border-50 placeholder:text-teal-800/50 placeholder:text-sm w-full h-10 appearance-none pl-5"
              >
                <option value="0">All Statuses</option>
                {orderStatusOptions.map((status) => (
                  <option
                    key={status.orderStatusId}
                    value={status.orderStatusId}
                  >
                    {status.orderStatusDescription}
                  </option>
                ))}
              </select>
              <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-600">
                ▼
              </div>
            </div>

            <div className="flex flex-wrap gap-y-4 items-center space-x-2">
              <input
                className="rounded-lg bg-transparent border custom-border-50 focus:border-2 focus:custom-border-50 placeholder:text-teal-800/50 placeholder:text-sm w-44 ml-2 h-10"
                type="date"
                name="startDate"
                value={startDate.split("/").join("-")}
                onChange={handleDateChange}
              />
              <input
                className="rounded-lg bg-transparent border custom-border-50 focus:border-2 focus:custom-border-50 placeholder:text-teal-800/50 placeholder:text-sm w-44 ml-2 h-10"
                type="date"
                name="endDate"
                value={endDate.split("/").join("-")}
                onChange={handleDateChange}
              />
              <button
                onClick={() => fetchData(startDate, endDate, orderStatus)}
                className="cta-one px-2 py-2 w-1/15 rounded-lg"
              >
                Go
              </button>
              {rows?.length > 0 &&
              userRoleId !== "ROLE_DEALER" &&
              userRoleId !== "ROLE_CUSTOMER" ? (
                <button
                  onClick={() => exportToExcel(rows, userRoleId)} // Call the export function with rows data
                  className="cta-one px-3 py-2 w-1/10 rounded-lg"
                >
                  Export to Excel
                </button>
              ) : null}

              <input
                type="search"
                className="rounded-lg bg-transparent border custom-border-50 focus:border-2 focus:custom-border-50 placeholder:text-teal-800/50 placeholder:text-sm w-44 ml-2 h-10"
                placeholder="Search"
                onChange={handleSearch}
              />
            </div>
          </div>
          {
            // console.log("conditionalRowStyles", conditionalRowStyles)
          }
          {userRoleId === "ROLE_DEALER" ? (
            rows.length > 0 && data.length > 0 ? (
              <DataTable
                columns={columns}
                data={data}
                conditionalRowStyles={conditionalRowStyles}
                fixedHeader
                pagination
                //customStyles={tableCustomStyles}
                //theme="solarized"
              />
            ) : (
              <h1 className="text-center">No Plan Found</h1>
            )
          ) : (
            <div className="lg:col-span-3 relative">
              {/* <div className="absolute bottom-[50px] z-50 w-full h-[200px] bg-grad"></div> */}
              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
                {rows?.length > 0 &&
                  rows?.map((item, index) => (
                    <OrderCard
                      key={index}
                      data={item}
                      brandIndex={item.networkId}
                      isPending={item.orderStatusDescription === "Pending" ? 1 : 0}
                      customFunction={handleProcessOrder}
                      dataValue={rows}
                    />
                  ))}
              </div>
              {rows?.length == 0 && (
                <div className="w-full min-h-screen flex flex-col items-center mt-24">
                  <LuSearchX className="text-5xl mb-2" />
                  <p>Sorry, we couldn't find any results</p>
                </div>
              )}
            </div>
          )}
        </main>
      </div>
      <ModalComponent
        size={
          modalInitState.contentId === "creditCheck" ||
          modalInitState.contentId === "referralPopup"
            ? "md"
            : null
        }
        type={
          modalInitState.contentId === "creditCheck"
            ? "error"
            : modalInitState.contentId === "referralPopup"
            ? "warning"
            : null
        }
        position={
          modalInitState.contentId === "creditCheck" ||
          modalInitState.contentId === "referralPopup"
            ? "center"
            : null
        }
        title={
          modalInitState.contentId === "creditCheck"
            ? "Credit check fail"
            : modalInitState.contentId === "referralPopup"
            ? "Credit Vetting Status"
            : null
        }
      >
        {modalInitState.contentId === "creditCheck" ? (
          <ModalForCredit
            navigate={navigate}
            dispatch={dispatch}
            handleCheckout={handleCheckout}
            checkoutFormRef={checkoutFormRef}
          />
        ) : modalInitState.contentId === "referralPopup" ? (
          <ModalForReferral
            navigate={navigate}
            dispatch={dispatch}
            // handleCheckout={handleCheckout}
            // checkoutFormRef={checkoutFormRef}
          />
        ) : null}
      </ModalComponent>

      {loader && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
};

export default MyOrder;
